import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { ContentItemRender } from "~/components/content/content-item-render";

export const StyledContentItemRender = styled(ContentItemRender)``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${props => props.theme.breakpoints.up("tablet")} {
    gap: 16px;
  }
  ${props => props.theme.breakpoints.up("homeDesktop")} {
    gap: 12px;
  }
`;

export const Title = styled.div`
  color: rgba(0, 0, 0, 0.5);
  font-weight: 400;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
  line-height: 23.5px;
  text-transform: uppercase;
`;
